import { CurrentRoute } from './router';

export function App() {
  return <CurrentRoute />;
}
